// Dependecies
import { combineReducers } from 'redux'


// Reducers
import { auth, authNotSaved } from './auth'
import { collections, collectionsMeta } from './collections'
import { educationLevels, educationLevelsOptions } from './education_levels'
import { mydActivity, mydActivities } from './myd_activities'
import { mydCompetences, mydCompetencesUsedInActivities } from './myd_competences'
import { mydUserCompetences } from './myd_user_competences'
import { evaluation } from './evaluations'
import { nodes, loadedNodes } from './nodes'
import { planning, plannings } from './plannings'
import { mydPlanning, mydPlannings } from './myd_plannings'
import { mydEvaluations, mydEvaluation } from './myd_evaluations'
import { teachers } from './teachers'
import { tasksToDo } from './tasks_to_do'
import { treeNodes } from './treeNodes'
import { widgets, widget, widgetsMeta, widgetPrivacy } from './widgets'
import { notifications } from './notifications'
import { languages } from './languages'
import { createStoryModal } from './createStoryModal'
import { methodologies } from './evaluation-methodologies'
import { instruments } from './evaluation-instruments'
import { coverImage } from './cover-image'
import { nav } from './nav'
import { forms } from './forms'
import { translations } from './i18n'
import { supportService } from './support'


export default combineReducers({
  auth,
  authNotSaved,
  collections,
  collectionsMeta,
  educationLevels,
  evaluation,
  educationLevelsOptions,
  mydActivity,
  mydActivities,
  mydCompetences,
  mydCompetencesUsedInActivities,
  mydUserCompetences,
  mydPlanning,
  mydPlannings,
  mydEvaluations,
  mydEvaluation,
  nodes,
  planning,
  plannings,
  teachers,
  tasksToDo,
  treeNodes,
  widgets,
  widget,
  widgetsMeta,
  widgetPrivacy,
  loadedNodes,
  notifications,
  languages,
  createStoryModal,
  methodologies,
  instruments,
  i18n: translations,
  coverImage,
  nav,
  forms,
  supportService,
})
